/** Opções de regime tributário (cadastro empresa/filial → DPS opSimpNac). */
export const REGIME_TRIBUTARIO_OPCOES = [
  { label: 'MEI', value: 'MEI' },
  { label: 'Simples Nacional (ME/EPP)', value: 'SimplesNacional' },
  { label: 'Lucro Presumido', value: 'LucroPresumido' },
  { label: 'Lucro Real', value: 'LucroReal' },
  { label: 'Outros / Não optante', value: 'Outros' },
];

export const AMBIENTE_FISCAL_OPCOES = [
  { label: 'Produção', value: 'Producao' },
  { label: 'Homologação', value: 'Homologacao' },
  { label: 'Produção Restrita', value: 'ProducaoRestrita' },
];

export const AMBIENTE_FISCAL_PADRAO = 'Producao';

/** Ajusta OptanteSimples conforme o regime escolhido. */
export function syncOptanteComRegime(regime, prevOptante) {
  if (regime === 'MEI' || regime === 'SimplesNacional') return true;
  if (regime === 'Outros' || (regime && String(regime).startsWith('Lucro'))) return false;
  return prevOptante;
}

export function syncRegimeComOptante(checked, prevRegime) {
  if (checked) return prevRegime === 'MEI' ? 'MEI' : 'SimplesNacional';
  if (prevRegime === 'MEI' || prevRegime === 'SimplesNacional') return 'Outros';
  return prevRegime;
}
